import { DifferentiationProps } from '@zola/zola-ui/src/components/PreAuthV3/Differentiation';
import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import { COLORS3 as COLORS } from '@zola/zola-ui/src/styles/emotion';

// Foreground Images
import AppMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/app_mobile.png';
import AppTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/app_tablet.png';
import AppDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/app_desktop.png';
import ChecklistMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/checklist_mobile.png';
import ChecklistTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/checklist_tablet.png';
import ChecklistDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/checklist_desktop.png';
import ExpertsMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/experts_mobile.png';
import ExpertsTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/experts_tablet.png';
import ExpertsDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/experts_desktop.png';
import GuestlistMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/guestlist_mobile.png';
import GuestlistTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/guestlist_tablet.png';
import GuestlistDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/guestlist_desktop.png';
import ToolsMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/tools_mobile.png';
import ToolsTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/tools_tablet.png';
import ToolsDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/tools_desktop.png';
import PaperMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/paper_mobile.png';
import PaperTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/paper_tablet.png';
import PaperDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/paper_desktop.png';
import RegistryMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/registry_mobile.png';
import RegistryTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/registry_tablet.png';
import RegistryDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/registry_desktop.png';
import WebsiteMobile from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/website_mobile.png';
import WebsiteTablet from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/website_tablet.png';
import WebsiteDesktop from '../../../../../public/static-preauth/images/WeddingPlanningLP/differentiation/website_desktop.png';

export const toolsDifferentiationContent: DifferentiationProps['content'] = [
  {
    id: 'experts',
    subtitle: 'Designed for you, by wedding experts',
    description:
      'No compromises, just best in class planning tools made for you, by wedding experts.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.BAY_100,
        },
      },
      foregroundImage: {
        desktopSrc: ExpertsDesktop,
        tabletSrc: ExpertsTablet,
        mobileSrc: ExpertsMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'tools',
    subtitle: 'See our tools work together, magically',
    description: 'Our tools are fully integrated to work for you, not against you.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.FOREST_100,
        },
      },
      foregroundImage: {
        desktopSrc: ToolsDesktop,
        tabletSrc: ToolsTablet,
        mobileSrc: ToolsMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'app',
    subtitle: 'Plan from anywhere with our five-star app',
    description:
      'Including exclusive features, like our countdown widget. Available for free on iOS.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.WINE_100,
        },
      },
      foregroundImage: {
        desktopSrc: AppDesktop,
        tabletSrc: AppTablet,
        mobileSrc: AppMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'guestlist',
    subtitle: 'The easiest guest list manager',
    description:
      'We’ll collect guests’ mailing addresses for you. Plus, track RSVPs for all your wedding events and record meal choices, plus ones, and more.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.MARINE_100,
        },
      },
      foregroundImage: {
        desktopSrc: GuestlistDesktop,
        tabletSrc: GuestlistTablet,
        mobileSrc: GuestlistMobile,
        imgType: 'png',
      },
    },
  },
];

export const everythingDifferentiationContent: DifferentiationProps['content'] = [
  {
    id: 'checklist',
    subtitle: 'Your custom wedding planning checklist',
    description:
      'Easy to customize with your wedding details, including cultural and religious traditions. You’ll even get helpful reminders when tasks are due.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.COVE_100,
        },
      },
      foregroundImage: {
        desktopSrc: ChecklistDesktop,
        tabletSrc: ChecklistTablet,
        mobileSrc: ChecklistMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'paper',
    subtitle: 'Beautiful save the dates, wedding invitations, and paper',
    description:
      'Hundreds of designs, affordable for every wedding budget, with free guest addressing, free shipping, and more.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.FOREST_100,
        },
      },
      foregroundImage: {
        desktopSrc: PaperDesktop,
        tabletSrc: PaperTablet,
        mobileSrc: PaperMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'website',
    subtitle: 'Free, matching wedding websites',
    description:
      'Hundreds of designs for every wedding style. Our easy to use, customizable templates have all the features you need, including digital RSVP.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.COVE_100,
        },
      },
      foregroundImage: {
        desktopSrc: WebsiteDesktop,
        tabletSrc: WebsiteTablet,
        mobileSrc: WebsiteMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'registry',
    subtitle: 'The most helpful registry',
    description:
      'So convenient, saving time for you and your guests, with gifts, gift cards, and zero-fee cash funds in one place. All with free shipping and returns, smarter exchanges, and more.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.WINE_100,
        },
      },
      foregroundImage: {
        desktopSrc: RegistryDesktop,
        tabletSrc: RegistryTablet,
        mobileSrc: RegistryMobile,
        imgType: 'png',
      },
    },
  },
];
